var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrashCan = function SvgTrashCan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m12.0751,16.00012l-8.40009,0c-0.66241,0 -1.20001,-0.59734 -1.20001,-1.33334l0,-10.66675l10.80011,0l0,10.66675c0,0.73601 -0.53761,1.33334 -1.20001,1.33334m1.80002,-12.66677l-12.00012,0l0,-1.33334l3.60004,0l0,-1.00001c0,-0.55134 0.4038,-1.00001 0.90001,-1.00001l3.00003,0c0.49501,0 0.90001,0.44734 0.90001,1.00001l0,1.00001l3.60004,0l0,1.33334zm-7.20007,-1.33334l2.40002,0l0,-0.66667l-2.40002,0l0,0.66667z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashCan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trashCan.e2fdc3cb.svg";
export { ForwardRef as ReactComponent };